import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["compatibilityType"];
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CompatibilityIcon(_ref) {
  let {
      compatibilityType
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  let backgroundColor;
  let iconName = SuccessIcon;
  switch (compatibilityType) {
    case 'COMPATIBLE_NONE':
      backgroundColor = 'fill-alert-pressed';
      iconName = RemoveIcon;
      break;
    case 'COMPATIBLE_SOME':
      backgroundColor = 'fill-accent-yellow-pressed';
      break;
    default:
      backgroundColor = 'fill-positive-default';
  }
  return /*#__PURE__*/_jsx(IconCircle, Object.assign({}, rest, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "data-test-id": `compatibility-icon-${compatibilityType}`,
    icon: iconName,
    color: "fill-surface-default",
    backgroundColor: backgroundColor,
    inlineSize: "8px",
    blockSize: "8px"
  }));
}